export default {"src":"/_next/static/media/briger.ca24db75.svg","height":25,"width":48,"blurWidth":0,"blurHeight":0};